import { useSmallerScreen } from 'hooks'
import React, { useEffect, useRef, useState } from 'react'
import { Icon } from 'components/ui'
import { CampaignTemplate } from 'types/domain'
import { useRouter } from 'next/router'
import { Signup } from 'config/constants'
import { Box, Button, Center, Container, Stack, Title } from '@mantine/core'
import PreviewActions from 'components/business/PlatformPreview/PreviewActions'
import { PlatformType } from 'components/business/PlatformPreview/type'
import Mobile from 'components/business/ChannelPreview'
import Web from 'components/business/ChannelPreview'
import { SurveyTemplatePreviewApi } from 'components/business/SurveyTemplatePreview'

type Props = {
  template: CampaignTemplate
}

const Template = ({ template }: Props) => {
  const router = useRouter()
  const [platform, setPlatform] = useState<PlatformType>('web')
  const smallerScreen = useSmallerScreen()
  const previewRef = useRef<SurveyTemplatePreviewApi | null>(null)

  useEffect(() => {
    smallerScreen && setPlatform('mobile')
  }, [platform, smallerScreen])

  const handleTplApply = () => {
    if (!template.code) {
      return
    }
    router.push({
      pathname: process.env.NEXT_PUBLIC_APP_URL! + Signup,
      query: {
        templateCode: template.code,
      },
    })
  }

  const handleRefresh = () => {
    previewRef.current?.refresh()
  }

  if (!template) {
    return null
  }
  return (
    <Container size={1200} p={0} className="pt-[123px]">
      <Stack justify="center" spacing={0}>
        <Stack spacing={0} className="px-[26px]">
          <Title
            order={1}
            weight={900}
            className="text-[32px] leading-[48px] mb-[8px] sm:mb-[12px] sm:text-[56px] sm:leading-[81px] text-center"
          >
            {template.title}
          </Title>
          <Title
            order={3}
            weight={400}
            className="text-[16px] leading-[24px] sm:text-[18px] sm:leading-[25px] text-center mb-[24px] sm:mb-[36px]"
          >
            {template.description}
          </Title>
        </Stack>
        <Center className="sm:pb-[56px] pb-[48px]">
          <Box w={210}>
            <Button
              fullWidth
              variant="default"
              size="lg"
              sx={(theme) => ({
                fontSize: theme.fontSizes.sm,
              })}
              leftIcon={<Icon name="sparkles" />}
              onClick={handleTplApply}
            >
              选用模板
            </Button>
          </Box>
        </Center>
        <Stack align="center" pos="relative" className="mx-[12px] sm:mx-0">
          <Center h="656px" w="100%">
            {platform === 'web' ? (
              <Web previewRef={previewRef} channel="web" template={template} />
            ) : (
              <Mobile previewRef={previewRef} channel="mobileApp" template={template} />
            )}
          </Center>
          {!smallerScreen && (
            <PreviewActions
              platformChangeable={true}
              widgetType={template?.widget.type}
              onPlatformClick={setPlatform}
              onRefresh={handleRefresh}
              className={`top-0  ${platform === 'web' ? 'right-[-60px]' : 'right-[350px]'}`}
            />
          )}
        </Stack>
      </Stack>
    </Container>
  )
}

export default Template
